/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AdGroupTargetingDto = {
  /**
   * 타겟 문제집 ID 목록
   */
  contentPackIds?: Array<string>;
  /**
   * 타겟 커리큘럼 ID 목록
   */
  curriculumIds?: Array<string>;
  /**
   * 타겟 카테고리 ID 목록
   */
  categoryIds?: Array<string>;
  /**
   * 벌어보카 지면 — 'include': 타겟팅 그룹도 벌어보카 노출 / 'exclude': 벌어보카 미노출 / 미지정: 논타겟 그룹만 노출(기본)
   */
  vocab?: AdGroupTargetingDto.vocab;
  /**
   * 모아토익 지면 — 'include': 타겟팅 그룹도 모아토익 노출 / 'exclude': 모아토익 미노출 / 미지정: 논타겟 그룹만 노출(기본)
   */
  toeic?: AdGroupTargetingDto.toeic;
  /**
   * 파트너 지면 opt-in — 비어 있으면 스웨치 앱에만 노출
   */
  partnerSurfaces?: Array<"PINCRUX">;
  /**
   * 제외 문제집 ID 목록
   */
  excludedContentPackIds?: Array<string>;
  /**
   * 제외 커리큘럼 ID 목록
   */
  excludedCurriculumIds?: Array<string>;
  /**
   * 제외 카테고리 ID 목록
   */
  excludedCategoryIds?: Array<string>;
};
export namespace AdGroupTargetingDto {
  /**
   * 벌어보카 지면 — 'include': 타겟팅 그룹도 벌어보카 노출 / 'exclude': 벌어보카 미노출 / 미지정: 논타겟 그룹만 노출(기본)
   */
  export enum vocab {
    INCLUDE = "include",
    EXCLUDE = "exclude",
  }
  /**
   * 모아토익 지면 — 'include': 타겟팅 그룹도 모아토익 노출 / 'exclude': 모아토익 미노출 / 미지정: 논타겟 그룹만 노출(기본)
   */
  export enum toeic {
    INCLUDE = "include",
    EXCLUDE = "exclude",
  }
}
